import React from 'react';
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import { startOfWeekMon, endOfWeekSun } from "../../utils/dateFunctions";
import DateSelector from "../../shared/DateSelector";
import { checkAccess } from '../../utils/roleFunctions';
import { ACCESS, ACCESS_SECTIONS } from '../../utils/constants/access';
import { useSearchParams } from "react-router-dom";
import BillsEditable from './Tables/BillsEditable';
import { userInfo } from "../../../adalConfig";
import { useTranslation } from "react-i18next";
import BillLines from './Tables/BillLines';

const BillsPage = (props) => {
    const { t } = useTranslation();
    const [startDate, setStartDate] = React.useState(startOfWeekMon(new Date()));
    const [endDate, setEndDate] = React.useState(endOfWeekSun(new Date()));
    const [data, setData] = React.useState(null);
    const [completed, setCompleted] = React.useState(false);
    const [reload, setReload] = React.useState(true);
    const [searchParams, setSearchParams] = useSearchParams();
    const workflowId = searchParams.get("workflowId");
    const [user, setUser] = React.useState(userInfo());
    const userName = user?.userName || "";
    const requiredEditAccess = { key: ACCESS_SECTIONS.AP, value: ACCESS.EDIT };

    const reloadFunc = () => {
        setReload(!reload);
    }

    return (
        <React.Fragment>
           
            <Grid container spacing={3.5}>
                <Grid item xs={12}>
                    <BillsEditable workflowId={workflowId} userName={userName} startDate={startDate} endDate={endDate} access={props.access} reloadFunc={reloadFunc} reload={reload} dashboard summary />
                </Grid>
            </Grid>
        </React.Fragment >
    );
};

export default BillsPage;
